import { render } from "./VerifyEmail.vue?vue&type=template&id=3efca4f7&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"

import "./VerifyEmail.vue?vue&type=style&index=0&id=3efca4f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efca4f7"],['__file',"src/views/public/VerifyEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3efca4f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3efca4f7', __exports__)) {
    api.reload('3efca4f7', __exports__)
  }
  
  module.hot.accept("./VerifyEmail.vue?vue&type=template&id=3efca4f7&scoped=true", () => {
    api.rerender('3efca4f7', render)
  })

}


export default __exports__